import { render, staticRenderFns } from "./orders-uploaded-progress.vue?vue&type=template&id=495a9a10&scoped=true"
import script from "./orders-uploaded-progress.vue?vue&type=script&lang=js"
export * from "./orders-uploaded-progress.vue?vue&type=script&lang=js"
import style0 from "./orders-uploaded-progress.vue?vue&type=style&index=0&id=495a9a10&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495a9a10",
  null
  
)

export default component.exports